import styled from 'styled-components';
import { Label } from './Label';
import { Colors } from '../../constants/colors';

type FormFieldProps = {
  disabled?: boolean
}

export const FormField = styled.div<FormFieldProps>`
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;

  ${({ disabled }) => disabled === true && `
    pointer-events: none;

    ${Label}, ${Label}::after {
      color: ${Colors.grey}
    }

    > div {
     opacity: 0.5;
    }
  `}
`;
